<template>
	<div class="login_box">
		<div class="p_flex p_box p_m_t_70">
			<div class="one_left">
				<div class="one_left-tiw"><img style="width: 100%;height: 100%;"  src="../../assets/img/Boss_Two Color.png" /></div>
			</div>
			<div class="one_two  ">
				<div>
					<span class="p_flex p_m_a_a p_m_a_b  subject_color type_size_30 ">{{ name == 'Retrieve' ? '手机验证' : '绑定手机号' }}</span>
				</div>
				<div class="two_box">
					<div class="p_flex p_login p_f_a">
						<span class=" type_size_18 p_m_a_c">手机号</span>
						<div class="p_f_1 p_m_a_c  type_size_18  "><el-input type="number" maxlength="11" v-model="account" placeholder="请输入手机号"></el-input></div>
					</div>
					<div class="p_flex p_login p_f_a p_m_t_30">
						<span class="p_m_a_c type_size_18 ">验证码</span>
						<div class="p_f_1 p_m_a_c type_size_18  "><el-input type="number" maxlength="6" v-model="password" placeholder="请输入验证码"></el-input></div>
						<div class="type_size_18  p_m_a_c p_m_a_d small_hand" :class="[countTimes == true ? 'subject_yellow' : 'yan_code forbid']" @click="verification">
							{{ countTimes == true ? '获取验证码' : seconds + 's后重新获取' }}
						</div>
					</div>
				</div>
				<div class="p_flex p_f_c subject_yellow type_size_20 small_hand p_m_t_180" @click="goSkip()" v-show="id == 1">
					跳过
				</div>
				<div class="p_m_t_50">
					<div class="two_com "><el-button type="success" @click="goLogin()">确认</el-button></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'mobile',
	data() {
		return {
			account: '',
			password: '',
			countTime: null,
			countTimes: true,
			seconds: 60,
			id: '',
			name: ''
		};
	},
	created() {
		// console.log(localStorage.getItem("userInfo"))
		this.id = localStorage.getItem('userInfo');
		// console.log(this.$route.query.id)
		this.name = this.$route.query.id;
	},
	methods: {
		goLogin() {
			if (this.name == 'Retrieve') {
				this.$request
					.ajax(this)
					.post('/api/forget_phone', {
						//手机验证
						phone: this.account,
						code: this.password,
						user_type: this.id == 0 ? 'teacher' : 'student'
					})
					.then(res => {
						// console.log(res)
						this.$router.push({
							path: 'Amend',
							query: {
								id: res.data
							}
						}); //修改密码
					});
			} else {
				this.$request
					.ajax(this)
					.post('/api/account_binding_phone', {
						//绑定手机号
						phone: this.account, //手机号
						code: this.password //验证码
					})
					.then(res => {
						// console.log(res)
						if (this.id == 0) {
							this.$router.push('/Homet'); //老师端
						} else {
							this.$router.push('/Homes'); //学生端
						}
					});
			}
		},
		verification() {
			const thta = this;
			if (thta.account == '') {
				thta.$message.error('手机号不能为空');
				return;
			}
			thta.$request
				.ajax(this)
				.post('/api/phone_code', {
					phone: this.account, //手机号
					code_type: this.name == 'empty' ? 'binding_phone' : 'reset_pwd' //验证码类型
				})
				.then(res => {
					console.log(res);
					this.$message.success('发送验证码成功！');
				});
			thta.countTimes = false;
			thta.countDown();
		},
		countDown() {
			const thta = this;
			thta.countTime = setInterval(function() {
				thta.seconds--;
				if (thta.seconds == 0) {
					thta.countTimes = true;
					thta.seconds = 60;
					clearInterval(thta.countTime);
					thta.countTime = null;
					return;
				}
			}, 1000);
		},
		goSkip() {
			this.$router.push('/Homes');
			// this.$router.push('/Amend');
		}
	}
};
</script>

<style lang="scss" scoped>
.one_left {
	width: 50%;
	background-color: #fafafa;
	border-radius: 20px 0px 0px 20px;
}
.one_left .one_left-tiw {
	width: 80%;
	margin: 15% auto 0;
}

.p_m_a_a{
	margin-top: 10%;
}

.p_m_a_b{
	margin-left: 15%;
}

.p_m_a_c{
	margin-left: 5%;
}


.p_m_a_d{
	margin-right: 5%;
}

.two_box{
	width: 70%;
	margin: 10% auto 0;
}

.p_login{
	width: 100%;
}

.one_two {
	 width: 50%;
	background: #ffffff;
	border-radius: 0px 20px 20px 0px;
}

.p_m_t_a{
	margin-top: 20%;
}

.p_m_t_b{
	margin-top: 15%;
}

.two_com {
	width: 50%;
	margin: 0 auto;
}

.two_log {
	width: 40%;
	margin: 10% auto 0;
	// background: #0000FE;
	// margin: 100px auto 0;
}

.el-button--success {
	width: 100%;
	margin: 0 auto;
}
.el-button {
	border-radius: 20px;
	font-size: 22px;
	padding: 20px;
}
.footer {
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}
.login_box {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 60%;
	height: 85%;
}
img {
	width: 100%;
	height: auto;
	object-fit: cover;
}
.p_box{
	width: 100%;
	height: 80%;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}


.footer{
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}



>>> input::-webkit-input-placeholder {
	font-size: 18px;
}

>>> input::-webkit-outer-spin-button,
>>> input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

>>> input[type='number'] {
	-moz-appearance: textfield;
}


.yan_code {
	color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/login/mobile.vue